// this file is automatically generated by app-version-info.ts script at build time
/* tslint:disable */export const appVersionInfo = {
  version: '4.155.0',
  revision: 'interface-4.155',
  dateTime: 1793810978977,
  branch: 'HEAD'};